// macadamia-app/src/macadamia-core/components/DragHandleContext.tsx
import React, { createContext, useContext } from 'react';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

interface DragHandleContextValue {
    listeners?: SyntheticListenerMap;
    attributes?: DraggableAttributes;
}

const DragHandleContext = createContext<DragHandleContextValue | null>(null);

export const DragHandleProvider: React.FC<{
    children: React.ReactNode;
    listeners?: SyntheticListenerMap;
    attributes?: DraggableAttributes;
}> = ({ children, listeners, attributes }) => {
    return (
        <DragHandleContext.Provider value={{ listeners, attributes }}>
            {children}
        </DragHandleContext.Provider>
    );
};

export const useDragHandle = () => {
    const context = useContext(DragHandleContext);
    if (context === null) {
        // En mode reader ou si pas dans un SortableBlock, retourner des valeurs vides
        return { listeners: undefined, attributes: undefined };
    }
    return context;
};
